import { Appearance } from '@stripe/stripe-js';

export const roomexStripeAppearance: Appearance = {
  theme: 'flat',
  variables: {
    colorPrimary: '#00B7B1',
    colorBackground: '#ffffff',
    colorText: '#434A51',
    colorDanger: '#D32F2F',
    colorSuccess: '#00B7B1',
    colorSuccessText: '#00B7B1',
    colorWarning: 'FBC02D',
    fontFamily: 'proxima-regular, proxima-bold, sans-serif',
    borderRadius: '4px',
    spacingTab: '8px',
    fontSizeSm: '14px',
    fontSizeBase: '16px',
    spacingGridRow: '16px',
  },
  rules: {
    '.Tab': {
      padding: '6px 16px',
      backgroundColor: '#F9F9F9',
      display: 'flex',
      height: '50px',
      flexDirection: 'row',
    },
    '.Tab:focus': {
      boxShadow: 'none',
    },
    '.TabLabel': {
      paddingTop: '10px',
    },
    '.Input': {
      border: '1px solid #A4A8AB',
      padding: '10px 12px',
    },
    '.Label': {
      fontWeight: '700',
    },
    '.CheckboxInput': {
      border: '1px solid #A4A8AB',
    },
  },
};

